module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2"
  }, [_c('div', {
    staticClass: "box-style line-top"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h1', [_vm._v("DETALLES DE TU PEDIDO GRUPAL")]), _vm._v(" "), _c('div', {
    staticClass: "box-date"
  }, [_c('a', {
    staticClass: "regular",
    attrs: {
      "href": "",
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cancelarClicked($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" cancelar pedido")])])])]), _vm._v(" "), (_vm.user) ? _c('div', {
    staticClass: "box-body"
  }, [_c('p', {
    staticClass: "text-size-18"
  }, [_vm._v("Administrador Grupal: "), _c('span', {
    staticClass: "regular"
  }, [_vm._v(_vm._s(_vm.user.displayName))])]), _vm._v(" "), _c('p', {
    staticClass: "text-size-18"
  }, [_vm._v("Empresa: "), _c('span', {
    staticClass: "regular"
  }, [_vm._v(_vm._s(_vm.user.sucursalAsociada.denominacion) + "-" + _vm._s(_vm.user.sucursalAsociada.empresa.razonSocial))])]), _vm._v(" "), _c('p', {
    staticClass: "text-size-18"
  }, [_vm._v("Teléfono: "), _c('span', {
    staticClass: "regular"
  }, [_vm._v(_vm._s(_vm.user.telefonoCelular))])]), _vm._v(" "), _c('p', {
    staticClass: "text-size-18"
  }, [_vm._v("Dirección de entrega: "), _c('span', {
    staticClass: "regular"
  }, [_vm._v(_vm._s(_vm.user.sucursalAsociada.direccion.direccion))])])]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._l((_vm.carrito), function(itemMenu, idx) {
    return (_vm.users) ? [_c('h4', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("fechaFormateadaEncabezado")(itemMenu.fecha)))]), _vm._v(" "), _vm._l((itemMenu.proveedor), function(proveedor, idxProveedor) {
      return _vm._l((proveedor.platos), function(plato, idxPlato) {
        return _c('div', {
          staticClass: "table-container margin-20"
        }, [_c('table', {
          staticClass: "table table-hover table-stripped table-responsivo table-checkout no-margin"
        }, [_c('tbody', [_c('tr', [_c('td', {
          staticClass: "col-sm-1"
        }, [_c('b', [_vm._v(_vm._s(_vm.calcularSinAsignar(plato)))])]), _vm._v(" "), _c('td', {
          staticClass: "col-sm-5"
        }, [(_vm.calcularSinAsignar(plato) > 0) ? _c('select-empleados', {
          key: idx + '-' + idxProveedor + '-' + idxPlato,
          attrs: {
            "plato": plato.plato,
            "fecha": itemMenu.fecha,
            "usuarios": _vm.users,
            "exclusiones": plato.asignaciones,
            "combo": _vm.comboActivo,
            "admin": _vm.user
          },
          on: {
            "select-empleado": _vm.onSelectEmpleado
          }
        }) : _c('span', {
          staticClass: "label label-info"
        }, [_vm._v("Plato completamente asignado")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(plato.plato.nombre))]), _vm._v(" "), _c('td', [_c('div', {
          staticClass: "quantity-actions text-right"
        }, [_c('div', {
          staticClass: "quantity"
        }, [_c('span', {
          staticClass: "qty-value"
        }, [_vm._v(_vm._s(plato.cantidad))])])])])])])])])
      })
    })] : _vm._e()
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "table-container margin-20"
  }, [_vm._l((_vm.carrito), function(item, idxItem) {
    return [_c('div', {
      staticClass: "date pull-right m-r-20 gris"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("fechaFormateadaEncabezado")(item.fecha)))])]), _vm._v(" "), _vm._l((item.proveedor), function(proveedor) {
      return [_c('table', {
        staticClass: "table table-hover table-stripped table-responsivo table-checkout no-margin"
      }, [_c('tbody', [_vm._l((_vm.usuariosConPlatoDia(item.fecha)), function(usuario) {
        return (_vm.usuariosConPlatoDia(item.fecha).length > 0) ? _vm._l((_vm.getAsignacionesUsuarioDia(item.fecha, usuario._id)), function(asignacion, idx) {
          return _c('tr', [(idx === 0) ? _c('td', {
            attrs: {
              "rowspan": _vm.getAsignacionesUsuarioDia(item.fecha, usuario._id).length
            }
          }, [(_vm.estaCompletoMenuUsuarioDia(item.fecha, asignacion.idEmpleado)) ? _c('i', {
            staticClass: "fa fa-check-circle verde",
            attrs: {
              "aria-hidden": "true"
            }
          }) : _c('i', {
            staticClass: "fa fa-warning",
            staticStyle: {
              "color": "#f0ad4e"
            }
          }), _vm._v(" " + _vm._s(usuario.displayName))]) : _vm._e(), _vm._v(" "), _c('td', {
            class: {
              'text-danger': _vm.noDisponibles.indexOf(asignacion.idPlato) >= 0
            }
          }, [(_vm.noDisponibles.indexOf(asignacion.idPlato) >= 0) ? _c('span', {
            staticClass: "label label-danger"
          }, [_vm._v("Sin stock suficiente")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.getNombrePlato(asignacion.idPlato)))]), _vm._v(" "), _c('td', [_c('div', {
            staticClass: "pull-right"
          }, [_c('span', [_vm._v(_vm._s(asignacion.cantidad))]), _vm._v(" "), _c('a', {
            staticClass: "btn btn-xs btn-ghost btn-eliminar",
            attrs: {
              "type": "button"
            },
            on: {
              "click": function($event) {
                _vm.desasignarPlato(item.fecha, asignacion.idPlato, asignacion.idEmpleado)
              }
            }
          }, [(asignacion.cantidad === 1) ? _c('i', {
            staticClass: "fa fa-actions fa-times"
          }) : _c('i', {
            staticClass: "fa fa-actions fa-minus"
          })])])])])
        }) : _vm._e()
      })], 2)])]
    })]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "box-actions text-center smart-form"
  }, [_c('p', {
    staticClass: "text-center margin-bottom-20"
  }, [_c('label', {
    staticClass: "checkbox inline-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.aceptaCondiciones),
      expression: "aceptaCondiciones"
    }],
    attrs: {
      "type": "checkbox",
      "name": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.aceptaCondiciones) ? _vm._i(_vm.aceptaCondiciones, null) > -1 : (_vm.aceptaCondiciones)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.aceptaCondiciones,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.aceptaCondiciones = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.aceptaCondiciones = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.aceptaCondiciones = $$c
        }
      }
    }
  }), _vm._v(" "), _c('i'), _vm._v("He revisado el pedido y es exactamente lo que quiero recibir\n                ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-fill",
    class: {
      disabled: !_vm.aceptaCondiciones
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onClickConfirmar($event)
      }
    }
  }, [_vm._v("CONFIRMAR")])])])], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header subline-top"
  }, [_c('h1', [_vm._v("ASIGNAR PLATOS A EMPLEADOS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h2', [_vm._v("AÚN SIN ASIGNAR")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h2', [_vm._v("ASIGNADOS")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3be7dcd7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pedido/CheckoutAdmin.vue
// module id = 1123
// module chunks = 5